// =====================================================
// iDMS Dashboard API Service
// Responsible for all dashboard backend communication
// =====================================================


import { Auth } from 'aws-amplify';


import {

    loadInstallations,

    confirmDeactivate 

}

from "./Dashboard";



const API_BASE_URL =

    //"https://YOUR_API_GATEWAY_URL";

    "https://jtt8y195dj.execute-api.us-west-2.amazonaws.com/beta";


/*
    Replace later with:

    https://xxxx.execute-api.us-west-2.amazonaws.com/prod

*/





// =====================================================
// Helper: Authorization Header
// =====================================================


const getHeaders = () => {


    const token =

        localStorage.getItem(
            "idms_token"
        );



    return {


        "Content-Type":

            "application/json",



        "Authorization":

            `Bearer ${token}`


    };


};






// =====================================================
// Get User Installations
// Reads idms_installation table
// =====================================================


export async function getInstallations(){

    try{

        const session =
                await Auth.currentSession();

        const token =
                session.getIdToken().getJwtToken();


        //console.log("getInstallations - token  : " + JSON.stringify(token, null, 2));    


        const response = await fetch(

            `${API_BASE_URL}/get-installations`,

            {

                method:"GET",

                //headers:getHeaders()

                headers: {
                            Authorization: `Bearer ${token}`
                         }

            }


        );


        const data = await response.json();


        console.log(
            "GET INSTALLATIONS RESPONSE:",
            data
        );

        return  data ;


        if(!response.ok){

            throw new Error(

                "Failed loading installations"
            );


        }


    }

    catch(error){

        console.error(

            "getInstallations error",

            error

        );

        return [];

    }


}



/*downloadEA = async () => {

        try {

            const session =
                await Auth.currentSession();

            const token =
                session.getIdToken().getJwtToken();


                 //console.log("token  : " + JSON.stringify(token, null, 2));    


            const response =
                await fetch(
                    "https://jtt8y195dj.execute-api.us-west-2.amazonaws.com/beta/download-bot",
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

            const data =
                await response.json();

                 console.log("data  : " + JSON.stringify(data, null, 2));    

            window.location.href =
                data.downloadUrl;

                this.setState({activationCode : data.activationCode}) ;
                this.setState({downloadUrl    : data.downloadUrl}) ;

                //console.log("this.state.activationCode ......  : " + JSON.stringify(this.state.activationCode, null, 2));    

        } catch (error) {

            console.error(error);
            alert("Download failed.");

        }
    };*/
    





// =====================================================
// Get License Information
// Reads activation/license data
// =====================================================


export async function getLicense(){


    try{

        const response = await fetch(

            `${API_BASE_URL}/get-license`,

            {

                method:"GET",

                headers:getHeaders()

            }

        );


        if(!response.ok){

            throw new Error(

                "Failed loading license"

            );


        }


        return await response.json();

    }


    catch(error){

        console.error(

            "getLicense error",

            error

        );


        return null;

    }


}








// =====================================================
// Deactivate MT5 Installation
// Updates idms_installation
// =====================================================


export async function deactivateInstallation(installationId) {



    try{

        const session =
                await Auth.currentSession();

        const token =
                session.getIdToken().getJwtToken();

        //console.log("installationId  : " + JSON.stringify(installationId, null, 2));    

        const response = await fetch(


            `${API_BASE_URL}/deactivate-installation`,


            {


                method:"POST",

                //headers:getHeaders(),

                headers:{

                    "Content-Type":"application/json",

                    Authorization: `Bearer ${token}`

                },


                body:JSON.stringify({

                        installationId: installationId


                })


            }



        );

            


        if(!response.ok){

            throw new Error(

                "Deactivate failed"

            );


        }

        const result = await response.json();

        
    if (result.success) {

        //this.confirmDeactivate();

        //this.closeDeactivate();


        //await this.loadInstallations();

        console.log(
        "Deactivate Lambda response : ",
         result.message
    );

    }


    console.log(
        "Deactivate Lambda response:",
        result
    );


        return  result;



    }


    catch(error){



        console.error(

            "deactivateInstallation error",

            error

        );



        return null;



    }



}







// =====================================================
// Get Activation Information
// Reads idms_activate table
// =====================================================


export async function getActivation(){



    try{


        const response = await fetch(


            `${API_BASE_URL}/get-activation`,


            {


                method:"GET",


                headers:getHeaders()


            }



        );




        return await response.json();



    }


    catch(error){



        console.error(

            "getActivation error",

            error

        );



        return null;


    }



}



// =====================================================
// DownloadEA - API - Lambda - S3
// =====================================================

export async function downloadEA() {

    try {

    //const token = await getToken();

    const session = await Auth.currentSession();

    const token   = session.getIdToken().getJwtToken();

    const response = await fetch ( API_BASE_URL + "/download-bot",

        {
            method: "GET",

            headers: {

                Authorization: `Bearer ${token}`

            }

        }

    );

           return await response.json();

    } catch (error) {

            console.error(error);
            alert("Download failed.");

   }

    

}